import { render } from "./VisitReview.vue?vue&type=template&id=54d61273&scoped=true"
import script from "./VisitReview.vue?vue&type=script&lang=js"
export * from "./VisitReview.vue?vue&type=script&lang=js"

import "./VisitReview.vue?vue&type=style&index=0&id=54d61273&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d61273"]])

export default __exports__